<template>
    <div id="some" ref="some" v-on:mousemove="mouseMove" v-on:mouseup="mouseUp">
        <div ref="linkList" id="linkList" v-on:mousemove="mouseMove" v-on:mouseup="mouseUp">
            <div class="tabs" v-on:mousedown="mouseDown"  v-on:mousemove="mouseMove" v-on:mouseup="mouseUp">
                <button v-bind:class="{active: list_mode === 'in'}" v-on:click="list_mode='in'">In({{inDomains.length + '/' + inLinks.length}})</button>
                <button v-bind:class="{active: list_mode === 'out'}" v-on:click="list_mode='out'">Out({{outDomains.length + '/' + outLinks.length}})</button>
                <button v-bind:class="{active: list_mode === 'errors'}" v-on:click="list_mode='errors'">Errors({{siteErrors.length}})</button>
                <button v-bind:class="{active: list_mode === 'redirects'}" v-on:click="list_mode='redirects'">3XX</button>
                <div class="placeholder stoned">
                    <button v-on:click="hideMe">X</button>
                </div>
            </div>
            <div class="tabs">
                <button class="site">{{site_info.url}}</button>
            </div>
            <div class="toolbar" v-if="list_mode === 'in'">
                <div class="sm-placeholder stoned"></div>
                <button v-bind:class="{active: toolbar_mode[list_mode] === 'domains'}" v-on:click="toolbar_mode[list_mode]='domains'">Domains({{inDomains.length}})</button>
                <button v-bind:class="{active: toolbar_mode[list_mode] === 'links'}" v-on:click="toolbar_mode[list_mode]='links'">Links({{inLinks.length}})</button>
                <div class="placeholder stoned"></div>
            </div>
            <div class="toolbar" v-if="list_mode === 'out'">
                <div class="sm-placeholder stoned"></div>
                <button v-bind:class="{active: toolbar_mode[list_mode] === 'domains'}" v-on:click="toolbar_mode[list_mode]='domains'">Domains({{outDomains.length}})</button>
                <button v-bind:class="{active: toolbar_mode[list_mode] === 'links'}" v-on:click="toolbar_mode[list_mode]='links'">Links({{outLinks.length}})</button>
                <div class="placeholder stoned"></div>
            </div>
            <template v-if="list_mode === 'in' || list_mode === 'out'">
                <p v-if="toolbar_mode[list_mode] === 'links'" class="links-header header stoned" v-on:mousedown="mouseDown"  v-on:mousemove="mouseMove"  v-on:mouseup="mouseUp"><span>From</span><span>To</span><span>Anchor</span><span>count</span></p>
                <p v-if="toolbar_mode[list_mode] === 'domains'" class="domain-header header stoned" v-on:mousedown="mouseDown"  v-on:mousemove="mouseMove"  v-on:mouseup="mouseUp"><span>Domain</span><span>Anchor</span><span>Links</span></p>
            </template>
            <p v-if="list_mode === 'errors'" class="header stoned" v-on:mousedown="mouseDown"  v-on:mousemove="mouseMove"  v-on:mouseup="mouseUp"><span>URL</span><span>Found on URL</span><span>HTTP Status</span><span>Errors</span></p>
            <div id="list-wrap">
                <div v-if="working > 0" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                <ul v-if="list_mode === 'in'">
                    <template  v-if="toolbar_mode[list_mode] === 'links'">
                        <li class="links-row" v-for="link in inLinks"><span>{{link.source_URL}}</span><span>{{link.URL}}</span><span>{{link.anchor}}</span><span>{{link.count}}</span></li>
                        <li v-if="(inLinks.length === 0) && (working === 0)" class="no-data"><span>No data</span><span>No data</span><span>No data</span><span>No data</span><span>No data</span></li>
                    </template>
                    <template v-if="toolbar_mode[list_mode] === 'domains'">
                        <template v-for="domain in inDomains">
                            <DomainRow v-bind:key="domain.key + 'in'" v-bind:domain="domain"></DomainRow>
                        </template>
                        <li v-if="(inDomains.length === 0) && (working === 0)" class="no-data"><span>No data</span><span>No data</span><span>No data</span><span>No data</span><span>No data</span></li>
                    </template>
                </ul>
                <ul v-if="list_mode === 'out'">
                    <template v-if="toolbar_mode[list_mode] === 'links'">
                        <li class="links-row" v-for="link in outLinks"><span>{{link.source_URL}}</span><span>{{link.URL}}</span><span>{{link.anchor}}</span><span>{{link.count}}</span></li>
                        <li v-if="(outLinks.length === 0) && (working === 0)" class="no-data"><span>No data</span><span>No data</span><span>No data</span><span>No data</span><span>No data</span></li>
                    </template>
                    <template v-if="toolbar_mode[list_mode] === 'domains'">
                        <template v-for="domain in outDomains">
                            <DomainRow v-bind:key="domain.key + 'out'" v-bind:domain="domain"></DomainRow>
                        </template>
                        <li v-if="(outDomains.length === 0) && (working === 0)" class="no-data"><span>No data</span><span>No data</span><span>No data</span><span>No data</span><span>No data</span></li>
                    </template>
                </ul>
                <ul v-if="list_mode === 'errors'">
                    <li v-for="link in siteErrors"><span>{{link.URL}}</span><span>{{link.source_URL}}</span><span>{{link.http_status}}</span><span>{{link.error}}</span></li>
                    <li v-if="(!siteErrors) && (working === 0)" class="no-data"><span>No data</span><span>No data</span><span>No data</span><span>No data</span><span>No data</span></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import * as d3 from 'd3';

    import config from '@/config'

    import DomainRow from '@/components/small/DomainRow'

    export default {
        name: "LinksList",
        components:{
            DomainRow,
            d3
        },
        props:{
            site_info: Object,
            hideMe: Function
        },
        mounted: function(){
            this.getLinks();
            this.getErrors();
        },
        data: function() {
            return {
                list_mode: "in",
                toolbar_mode: {
                    'in': 'domains',
                    'out': 'domains'
                },
                mouse_down: false,
                links: [],
                domains: {in: null, out: null},
                errors: [],
                working: 0,
                expanded: []
            }
        },
        computed:{
            inLinks: function(){
                if (!this.links){return []}
                let data = this.links.filter(link => {
                    // console.log(link.host + ' ' + this.site_info.host + ' ' + link.source_host)
                    return (link.source_host !== this.site_info.host);
                });

                return data;
            },
            outLinks: function(){
                if (!this.links){return false;}

                let data = this.links.filter(link => {
                    return (link.host !== this.site_info.host);
                });

                return data;
            },
            inDomains: function () {
                let data = d3.nest()
                    .key(function (d) {return d.source_host;})
                    .key(function (d) {return d.anchor;})
                    .rollup(
                        function (v) {
                            return d3.sum(v, function (d) {
                                return d.count;
                            });
                        })
                    .entries(this.inLinks);

                console.log(data);

                data.forEach( item => {
                    let grand = 0;

                    item.values.forEach( inner => {
                        grand += inner.value;
                        inner.links =  this.inLinks.filter((link) => {
                            return link.anchor === inner.key;
                        })
                    });

                    item.value = grand;
                });

                return data ? data : []
            },
            outDomains: function () {
                let data = d3.nest()
                    .key(function (d) {return d.host;})
                    .key(function (d) {return d.anchor;})
                    .rollup(
                        function (v) {
                            return d3.sum(v, function (d) {
                                return d.count;
                            });
                        })
                    .entries(this.outLinks);

                console.log(data);

                data.forEach( item => {
                    let grand = 0;

                    item.values.forEach( inner => {
                        inner.expanded = false;
                        inner.links =  this.outLinks.filter((link) => {
                            return link.anchor === inner.key;
                        })
                        grand += inner.value;
                    });

                    item.value = grand;
                });

                return data ? data : []
            },
            siteErrors: function () {
                if (!this.errors){return []}

                return this.errors
            }
        },
        methods:{
            expandMe: function(domain){
                console.log(domain);
                if (domain.expanded == null){
                    domain.expanded = true;
                }else{
                    domain.expanded = !domain.expanded;
                }
            },
            startWork: function(){
                this.working++;
            },
            endWork: function(){
                this.working--;
            },
            mouseDown(){
                this.mouse_down = true;
            },
            mouseUp(){
                this.mouse_down = false;
            },
            mouseMove(event){
                if (this.mouse_down){
                    let left = this.$refs.some.getBoundingClientRect().left + event.movementX;
                    let top = this.$refs.some.getBoundingClientRect().top + event.movementY;

                    this.$refs.some.style.top = top;
                    this.$refs.some.style.left = left;

                    event.stopPropagation()
                }
            },
            getErrors: async function () {
                this.errors = [];
                this.startWork();
                let request_url = config.api_url + '/?op=errors&id=' + this.site_info.host;
                axios
                    .get(request_url)
                    .then(response => {
                        this.errors = response.data;
                        this.endWork()
                    })
                    .catch(error => {
                        console.log(error)
                        this.endWork()
                    });
            },
            getLinks: async function () {
                this.links = [];
                this.startWork()
                let request_url = config.api_url + '/?op=links&id=' + this.site_info.host;
                axios
                    .get(request_url)
                    .then(response => {
                        this.links = response.data;
                        this.endWork()
                    })
                .catch(error => {
                    console.log(error)
                    this.endWork()
                });
            },
            getAnchors: async function () {
                this.anchors = [];
                this.startWork()
                let request_url = config.api_url + '/?op=anchors&id=' + this.site_info.host;
                axios
                    .get(request_url)
                    .then(response => {
                        this.anchors = response.data;
                        this.endWork()
                    })
                    .catch(error => {
                        console.log(error)
                        this.endWork()
                    })
            },
            getDomains: async function () {
                this.anchors = [];
                this.startWork()
                let request_url = config.api_url + '/?op=domains&id=' + this.site_info.host;
                axios
                    .get(request_url)
                    .then(response => {
                        this.domains = response.data;
                        this.endWork()
                    })
                    .catch(error => {
                        console.log(error)
                        this.endWork()
                    })
            }
        }
    }
</script>
<style scoped>
    #some{
        position: absolute;
        top: 10%;
        left: 10%;
        width: 80%;
        height: 80%;
        z-index: 100000;
    }

    #linkList{
        top: 0;
        left: 0;
        position: relative;
        background: #CCCCCC;
        width: 100%;
        min-height: 40%;
        height: 100%;
        border-right: 2px solid #FFFFFF;
        border-top: 2px solid #FFFFFF;
        border-bottom: 2px solid #656565;
        border-left: 2px solid #656565;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        box-shadow: 0px 0px 2px 1px #333;
    }

    #linkList #list-wrap{
        max-height: 80%;
        overflow-y: auto;
    }

    #linkList ul{
        overflow-y: unset;
        background-color: #888;
    }

    ul li span a{
        color: #4e4872;
    }

    #linkList ul li, .header{
        list-style: none;
        display: flex;
        flex-wrap: nowrap;
        border-top: 1px solid #ffffff;
        border-right: 1px solid #ffffff;
        background: #dfdfdf;  /* fallback for old browsers */
        padding: 0.5rem;
        color: #000000;
        border-bottom: 1px solid #888;
        border-left: 1px solid #888;
        text-shadow: none;
    }

    #linkList ul li.no-data{
        color: #a9a9a9;
        text-align: center;
        text-shadow: 1px 1px 0px #FFF;
    }

    #linkList ul li .shadow{
        color: #b9b9b9;
    }

    #linkList .header{
        list-style: none;
        display: flex;
        justify-items: center;
        justify-content: space-between;
        flex-wrap: nowrap;
        border-right: 1px solid #b9f1ff;
        background: #7bc4ff;  /* fallback for old browsers */
        background: -webkit-linear-gradient(to bottom, #7bc4ff, #c7e9ff);  /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to bottom, #7bc4ff, #c7e9ff); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        padding: 0.5rem;
        color: #FFFFFF;
        text-decoration: underline;
        border-bottom: 1px solid #4d7399;
        border-left: 1px solid #4d7399;
        text-shadow: 1px 1px 0px #888;
    }

    .header{
        border-top: 0;
    }


    #linkList .domain-header span:last-of-type, #linkList .links-header span:last-of-type{
        text-align: right;
    }

    #linkList .domain-header{
        display: grid;
        grid-template-columns: 1fr 2fr 1fr;
        justify-items: unset;
    }

    #linkList .links-header, #linkList ul li.links-row{
        display: grid;
        grid-template-columns: 2fr 2fr 1.5fr 0.5fr;
        justify-items: unset;
    }

    #linkList ul li.links-row span:last-of-type{
        text-align: right;
    }

    #linkList ul li.mygrid {
        display: grid;
        grid-template-columns: 1fr 2fr 0.5fr;
    }

    .tabs, .toolbar{
        display: flex;
    }

    .tabs button.site{
        margin: 0.5rem 0;
        color: #0000ee;
        border: 0;
        background-color: unset;
        text-shadow: none;
    }

    button:focus{
        outline: none;
    }

    .tabs button{
        border: 0;
        padding: 0.5rem;
        border-bottom: 0;
        text-decoration: underline;
        font-size: 1rem;
        text-shadow: 1px 1px 0px #FFFFFF;
        cursor: pointer;
        background-color: #d8d7d7;
        border-bottom: 1px solid #888;
        color: darkblue;
    }

    .tabs button.active{
        cursor: unset;
        color: #fff;
        text-decoration: none;
        background: #7bc4ff;  /* fallback for old browsers */
        padding: 0.5rem;
        color: #FFF;
        border-top: 1px solid #FFF;
        border-right: 0;
        border-bottom: 1px solid #436385;
        text-shadow: 1px 1px 0px #4e1b14;
        font-weight: bold;
    }

    .tabs button:first-of-type {
        border-left: 0;
    }

    .toolbar{
        background-color: unset;
        border-bottom: #FFFFFF;
    }

    .toolbar button{
        display: flex;
        flex: 1;
        border-top: 0;
        background: #476b8e;  /* fallback for old browsers */
        padding: 0.5rem;
        color: #FFF;
        border-bottom: 1px solid #FFFFFF;
        border-top: 1px solid #AAA;
        border-left: 0;
        border-right: 0;
    }

    .toolbar button.active{
        border-top: 1px solid #FFFFFF;
        background: #7bc4ff;  /* fallback for old browsers */
        font-weight: bold;
        text-shadow: 1px 1px 0px #4e1b14;
        border-left: 1px solid #656565;
        border-right: 1px solid #FFF;
        border-bottom: 0;
    }

    .toolbar .placeholder{
        border-bottom: 1px solid #FFFFFF;
    }

    .placeholder{
        flex: 10 90%;
        text-align: right;
    }

    .sm-placeholder{
        flex: 1 1rem
    }

    .tabs .placeholder{
        background-color: #6b659b;
        border-bottom: 1px solid #3f3961;
    }

    .placeholder button{
        background-color: darkred;
        color: #FFFFFF;
        text-shadow: 1px 1px 0px #425360;
        border-top: 1px solid #be0000;
        border-bottom: 1px solid #630000;
        border-right: 1px solid #be0000;
        border-left: 1px solid #630000;
        text-decoration: none;
        padding: 1rem;
    }

    .lds-ellipsis {
        text-align: center;
        display: block;
        position: relative;
        width: 64px;
        height: 64px;
        margin: auto;
    }
    .lds-ellipsis div {
        position: absolute;
        top: 27px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: #fff;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .lds-ellipsis div:nth-child(1) {
        left: 6px;
        animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(2) {
        left: 6px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(3) {
        left: 26px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(4) {
        left: 45px;
        animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }
    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(19px, 0);
        }
    }
</style>
